export enum AppEnv {
  DEVELOPMENT = 'DEVELOPMENT',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
}

export enum CurrencyCode {
  AUD = 'AUD',
  BRL = 'BRL',
  CAD = 'CAD',
  CNY = 'CNY',
  CZK = 'CZK',
  DKK = 'DKK',
  EUR = 'EUR',
  HKD = 'HKD',
  ILS = 'ILS',
  MYR = 'MYR',
  MXN = 'MXN',
  NZD = 'NZD',
  NOK = 'NOK',
  PHP = 'PHP',
  PLN = 'PLN',
  GBP = 'GBP',
  SGD = 'SGD',
  SEK = 'SEK',
  CHF = 'CHF',
  THB = 'THB',
  USD = 'USD',

  // Currencies with zero decimals are temporarily disabled.
  // HUF = 'HUF',
  // JPY = 'JPY',
  // TWD = 'TWD',
}
